export default __webpack_public_path__ + "static/media/Cog.1f8fb524.svg";